/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PaintBrushHousehold(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={72}
        y1={104}
        x2={151.99999}
        y2={183.99999}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={101.75578}
        y1={183.37379}
        x2={70.56478}
        y2={214.56478}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={73.75578}
        y1={155.37379}
        x2={42.56478}
        y2={186.56478}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default PaintBrushHousehold;
